(function() {
  function initMulticolumnModal(modalId, blocksData, translations) {
    var modal = document.getElementById(modalId);
    if (!modal) return;
    
    var cards = document.querySelectorAll('#Slider-' + modalId.replace('Modal-', '') + ' [data-modal-trigger]');
    var closeBtn = modal.querySelector('.multicolumn-modal__close');
    var overlay = modal.querySelector('.multicolumn-modal__overlay');
    
    var blocks = blocksData;

    cards.forEach(function(card) {
      card.addEventListener('click', function(e) {
        var blockId = card.dataset.blockId;
        var data = blocks[blockId];
        
        if (!data || !data.enableModal) return;
        
        var target = e.target;
        var clickedLink = target.closest('a');
        var clickedButton = target.closest('button');
        
        if (clickedLink || clickedButton) {
          e.preventDefault();
          e.stopPropagation();
        }
        
        e.preventDefault();
        e.stopPropagation();
        
        modal.querySelector('.multicolumn-modal__text-content').style.display = 'none';
        modal.querySelector('.multicolumn-modal__files-content').style.display = 'none';
        modal.querySelector('.multicolumn-modal__form-content').style.display = 'none';
        
        modal.querySelector('.multicolumn-modal__sidebar-title').innerHTML = data.cardTitle || '';
        
        if (data.contentType === 'text') {
          var container = modal.querySelector('.multicolumn-modal__text-content');
          var titleEl = container.querySelector('.multicolumn-modal__title');
          var textEl = container.querySelector('.multicolumn-modal__text');
          titleEl.innerHTML = data.title || '';
          textEl.innerHTML = data.text || '';
          
          var isMobile = window.innerWidth <= 749;
          titleEl.style.fontSize = (isMobile ? data.headingFontSizeMobile : data.headingFontSize) + 'px';
          textEl.style.fontSize = (isMobile ? data.textFontSizeMobile : data.textFontSize) + 'px';
          
          container.style.display = 'block';
        } 
        else if (data.contentType === 'files') {
          var container = modal.querySelector('.multicolumn-modal__files-content');
          var titleEl = container.querySelector('.multicolumn-modal__title');
          titleEl.innerHTML = data.title || '';
          
          var isMobile = window.innerWidth <= 749;
          titleEl.style.fontSize = (isMobile ? data.headingFontSizeMobile : data.headingFontSize) + 'px';
          
          var downloadsHTML = '';
          data.downloads.forEach(function(dl) {
            if (dl.url) {
              downloadsHTML += '<a href="' + dl.url + '" class="download-item" target="_blank" download>' +
                '<div class="download-item__preview">' +
                  (dl.image ? '<img src="' + dl.image + '" alt="">' : '<div class="download-item__placeholder"></div>') +
                '</div>' +
                '<span class="download-item__label">' + dl.label + '</span>' +
              '</a>';
            }
          });
          container.querySelector('.multicolumn-modal__downloads-grid').innerHTML = downloadsHTML;
          container.querySelector('.multicolumn-modal__downloads-note').innerHTML = data.downloadsNote || '';
          container.style.display = 'block';
        } 
        else if (data.contentType === 'form') {
          var container = modal.querySelector('.multicolumn-modal__form-content');
          var titleEl = container.querySelector('.multicolumn-modal__title');
          var textEl = container.querySelector('.multicolumn-modal__form-text');
          
          if (!titleEl) return;
          
          titleEl.innerHTML = data.formTitle || '';
          if (textEl && data.formText) {
            textEl.innerHTML = data.formText;
            textEl.style.display = 'block';
          } else if (textEl) {
            textEl.style.display = 'none';
          }
          
          function updateFormFontSizes() {
            var isMobile = window.innerWidth <= 749;
            titleEl.style.fontSize = (isMobile ? data.headingFontSizeMobile : data.headingFontSize) + 'px';
            if (textEl && data.formText) {
              textEl.style.fontSize = (isMobile ? data.textFontSizeMobile : data.textFontSize) + 'px';
            }
          }
          
          updateFormFontSizes();
          
          window.addEventListener('resize', function() {
            if (modal.classList.contains('active') && container.style.display !== 'none') {
              updateFormFontSizes();
            }
          });
          
          container.querySelector('.form-submit-btn').textContent = data.formSubmitText || translations.submit;
          
          var pubField = container.querySelector('.form-field--publication');
          if (data.formShowPublication) {
            pubField.style.display = 'block';
            pubField.querySelector('input').required = true;
          } else {
            pubField.style.display = 'none';
            pubField.querySelector('input').required = false;
          }
          container.style.display = 'block';
        }
        
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    });

    function closeModal() {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);
    
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal();
      }
    });
    
    var form = modal.querySelector('.multicolumn-modal__form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var messageEl = form.querySelector('.form-message');
        var submitBtn = form.querySelector('.form-submit-btn');
        var originalText = submitBtn.textContent;
        
        submitBtn.disabled = true;
        submitBtn.textContent = translations.sending;
        messageEl.style.display = 'none';
        messageEl.className = 'form-message';
        
        var formData = new FormData(form);
        
        fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'text/html'
          }
        })
        .then(function(response) {
          if (response.ok) {
            return response.text().then(function(html) {
              var isSuccess = html.includes('form-posted-successfully') || 
                             html.includes('form-status') || 
                             html.includes('success') ||
                             response.status === 200;
              
              if (isSuccess) {
                messageEl.textContent = translations.success;
                messageEl.className = 'form-message form-message--success';
                messageEl.style.display = 'block';
                form.reset();
              } else {
                var errorMatch = html.match(/form-status.*?error|error.*?form-status/i);
                if (errorMatch) {
                  throw new Error('Form submission failed');
                } else {
                  messageEl.textContent = translations.success;
                  messageEl.className = 'form-message form-message--success';
                  messageEl.style.display = 'block';
                  form.reset();
                }
              }
            });
          } else {
            throw new Error('Network response was not ok');
          }
        })
        .catch(function(err) {
          messageEl.textContent = translations.error;
          messageEl.className = 'form-message form-message--error';
          messageEl.style.display = 'block';
        })
        .finally(function() {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        });
      });
    }
  }

  if (typeof window.initMulticolumnModal === 'undefined') {
    window.initMulticolumnModal = initMulticolumnModal;
  }
})();
